<template>
    <div class="error-page">
        <navTop :isLogin="1" title="开发中"></navTop>
        <div class="error-code">开<span>发</span>中</div>
        <div class="error-desc"></div>
        <nav-bom></nav-bom>
    </div>
</template>

<script>
    import navTop from '../nav/nav-top.vue'
    import navBom from '../nav/nav-bom.vue'

    export default {
        components: {
            navTop,
            navBom
        },
        data() {
            return {}
        },
        methods: {}
    }
</script>

<style scoped lang="less">
    @import '../../../static/less/xm.less';

    .error-page {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
        height: @a;
        background: #f3f3f3;
        box-sizing: border-box;
    }

    .error-code {
        line-height: 1;
        font-size: 250px;
        font-weight: bolder;
        color: #2d8cf0;
    }

    .error-code span {
        color: #00a854;
    }

    .error-desc {
        font-size: 30px;
        color: #777;
    }

    .error-handle {
        margin-top: 30px;
        padding-bottom: 200px;
    }

    .error-btn {
        margin-left: 100px;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/404.vue